import paymentMethodsReducers from './reducers'

export { default as paymentMethodsTypes } from './types'
export { default as paymentMethodsActions } from './actions'
export { default as paymentMethodsSelectors } from './selectors'

export default paymentMethodsReducers
